import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';
import { Text } from '../../typography';
import { useTheme } from 'styled-components/macro';

declare global {
  interface Window {
    mtcaptcha?: {
      enableTestMode: (...params: any) => any;
      renderUI: (...params: any) => any;
    };
  }
}

const MTCaptchaStyled = styled.div`
  display: inline-block;
  width: auto;

  iframe {
    width: auto;
  }
`;

type MTCaptchaProps = {
  siteKey: string;
  testKey?: string;
  error?: String;
  mtCaptchaConfig?: Record<string, string>;
  style?: React.CSSProperties;
};
function MTCaptcha(props: MTCaptchaProps) {
  const { style, siteKey, testKey, mtCaptchaConfig, error } = props;
  const theme = useTheme();

  const mtCaptchaConfigString = mtCaptchaConfig
    ? Object.entries(mtCaptchaConfig).reduce((s, e) => {
        const newString = s + `"${e[0]}": "${e[1]}",`;
        return newString;
      }, '')
    : '';

  React.useEffect(() => {
    if (siteKey) {
      const s = document.createElement('script');
      s.type = 'text/javascript';
      s.async = true;
      s.innerHTML = `
      var mtcaptchaConfig = {
        "sitekey": "${siteKey}",
        ${mtCaptchaConfigString}
      };`;
      document.body.appendChild(s);

      const mtService = document.createElement('script');
      mtService.src =
        'https://service.mtcaptcha.com/mtcv1/client/mtcaptcha.min.js';
      mtService.async = true;
      document.body.appendChild(mtService);

      const mtService2 = document.createElement('script');
      mtService2.src =
        'https://service2.mtcaptcha.com/mtcv1/client/mtcaptcha2.min.js';
      mtService2.async = true;
      document.body.appendChild(mtService2);
    }
  }, [siteKey, mtCaptchaConfigString]);

  React.useEffect(() => {
    if (testKey && window.mtcaptcha) {
      window.mtcaptcha.enableTestMode(testKey);
    }
  }, [testKey]);

  // to avoid the captcha not being shown
  // if the script was already initialized
  React.useEffect(() => {
    if (window.mtcaptcha) window.mtcaptcha.renderUI();
  }, []);

  return (
    <MTCaptchaStyled style={style}>
      <div className="mtcaptcha" />
      {error && <Text style={{ color: theme.colors.danger }}>{error}</Text>}
    </MTCaptchaStyled>
  );
}

MTCaptcha.propTypes = {
  style: PropTypes.object,
  siteKey: PropTypes.string,
  testKey: PropTypes.string,
  error: PropTypes.string,
};

export default MTCaptcha;
